import React from 'react'
import * as moment from 'moment'
import { Env } from '@morningtrain/helpers'
import { CalendarLayout } from 'ui/calendar'
import CalendarHeader from 'ui/calendar/CalendarHeader'
import { useOnConstrain } from '@morningtrain/react-filters'
import get from 'lodash/get'

function SpecialDaysCalendar (props) {
  const defaultYear = Env.get('resources.api.shifts.special_days.month.filters.month.value.year') || moment().year()
  const defaultMonth = Env.get('resources.api.shifts.special_days.month.filters.month.value.month') || moment().month()

  const [currentMonth, setCurrentMonth] = React.useState({ month: defaultMonth, year: defaultYear })
  const [days, setDays] = React.useState([])

  useOnConstrain((constaints) => {
    const monthConstraint = get(constaints, 'month', { month: defaultMonth, year: defaultYear })
    setCurrentMonth(monthConstraint)
  })

  let lastMondayOfPreviousMonth = moment()
    .subtract(1, 'M')
    .endOf('month')
    .startOf('isoWeek')

  const daysInFullCalendar = 7 * 6

  React.useEffect(() => {
    const daysInPeriod = []

    lastMondayOfPreviousMonth = moment()
      .month(currentMonth.month)
      .year(currentMonth.year)
      .subtract(1, 'M')
      .endOf('month')
      .startOf('isoWeek')

    for (let i = 0; i < daysInFullCalendar; i++) {
      daysInPeriod.push(lastMondayOfPreviousMonth.clone().add(i, 'day'))
    }

    setDays(daysInPeriod)
  }, [currentMonth])

  return (
    <div>
      <CalendarHeader />
      <CalendarLayout>
        {days.map((day) => {
          return React.createElement(React.Fragment, { key: day }, React.Children.map(props.children, function (child) {
            return React.cloneElement(child, {
              date: day,
              currentMonth: currentMonth.month,
              currentYear: currentMonth.year
            })
          }))
        })}
      </CalendarLayout>
    </div>
  )
}

SpecialDaysCalendar.defaultProps = {}

SpecialDaysCalendar.propTypes = {}

export default SpecialDaysCalendar
